import { createUseStyles } from 'react-jss'
import { regularFont } from 'styles/helpers'

const buttonLinkStyles = createUseStyles(theme => ({
  buttonLink: {
    display: 'inline-block',
    color: theme.main_color,
    backgroundColor: 'transparent',
    textDecoration: 'none',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    ...regularFont(),

    '&:hover': {
      textDecoration: 'underline'
    },
  }
}))

export default buttonLinkStyles
